import SearchIcon from '@mui/icons-material/Search';

import Fab from '@mui/material/Fab';

import {useGlobalCustomContext} from '../../../../../../Helpers/context';
import {NODE_ACTIONS} from '../../../../Reducers/node';

import './index.scss';

export default function GlobalSearchNodeButton() {
    const {nodeState, nodeDispatch} = useGlobalCustomContext();

    const onSearchToggle = () => {
        if (!nodeState.globalSearchVisible) {
            document.body.classList.add('search')
        } else {
            document.body.classList.remove('search')
        }

        nodeDispatch({type: NODE_ACTIONS.GLOBAL_SEARCH_TOGGLE, data: !nodeState.globalSearchVisible});
    }

    return <Fab color="contrast" onClick={onSearchToggle}><SearchIcon /></Fab>
}
